/*
 * formatMultiSelect - a checkbox dropdown for selecting one OR MORE movie formats.
 *
 * Used by the two showtime detail views (Film/Detail.Custom.cshtml and
 * Cinema/Detail.MovieShowtimes.cshtml) in place of the old single-select format
 * dropdown.  It writes directly into the controller's canonical mvm.selectedFormats
 * array (added 2026-08 when the IMAX / C Premium family grouping was removed).
 *
 * The homepage deliberately keeps a plain single <select> for now; this directive
 * is the "multi" surface.  Because the controller already treats format selection as
 * an array, the homepage can adopt this directive later with no controller changes.
 *
 * Bindings (isolated scope):
 *   options="<array of format strings>"   e.g. mvm.movieFormatFilterArray
 *   selected="<the selection array>"      e.g. mvm.selectedFormats   (two-way, mutated in place)
 *   is-available="<fn(fmt)>"              e.g. mvm.isFormatOptionAvailable(fmt)  (grays unavailable)
 *   on-change="<expr>"                    e.g. mvm.AOSRefresh()       (fired after each toggle/clear)
 *   label-all="All Formats"               button text when nothing is selected
 *
 * Registered on cstudioApp.directives (created by app.js), so it loads in both the
 * ShowtimeBundle.min.js and CelebrationScripts.min.js bundles.
 */
(function () {
    function formatMultiSelect($document) {
        return {
            restrict: 'E',
            scope: {
                options: '=',
                selected: '=',
                isAvailable: '&',
                onChange: '&',
                labelAll: '@'
            },
            template:
                '<div class="format-multiselect" ng-class="{open: isOpen}">' +
                '  <button type="button" class="format-multiselect-toggle" ng-click="toggleOpen($event)" aria-haspopup="true" aria-expanded="{{isOpen}}">' +
                '    <span class="format-multiselect-label">{{buttonLabel()}}</span>' +
                '  </button>' +
                '  <div class="format-multiselect-panel" ng-show="isOpen">' +
                '    <ul class="format-multiselect-list">' +
                '      <li ng-repeat="opt in options | orderBy:\'toString()\'" class="format-multiselect-option" ng-class="{disabled: !available(opt), selected: isChecked(opt)}">' +
                '        <label>' +
                '          <input type="checkbox" ng-checked="isChecked(opt)" ng-disabled="!available(opt)" ng-click="onToggle(opt, $event)" />' +
                '          <span class="format-multiselect-name">{{opt}}</span>' +
                '          <span class="format-multiselect-none" ng-if="!available(opt)"> (none)</span>' +
                '        </label>' +
                '      </li>' +
                '    </ul>' +
                '    <button type="button" class="format-multiselect-clear" ng-show="selected.length" ng-click="clearAll($event)">Clear formats</button>' +
                '  </div>' +
                '</div>',
            link: function (scope, element) {
                scope.isOpen = false;

                scope.available = function (opt) {
                    // is-available may be omitted; default to available
                    if (!scope.isAvailable) { return true; }
                    var res = scope.isAvailable({ fmt: opt });
                    return res === undefined ? true : !!res;
                };

                scope.isChecked = function (opt) {
                    return _.some(scope.selected, function (f) {
                        return String(f).trim() === String(opt).trim();
                    });
                };

                scope.buttonLabel = function () {
                    var count = scope.selected ? scope.selected.length : 0;
                    if (count === 0) { return scope.labelAll || 'All Formats'; }
                    if (count === 1) { return scope.selected[0]; }
                    return count + ' formats';
                };

                scope.toggleOpen = function ($event) {
                    if ($event) { $event.preventDefault(); $event.stopPropagation(); }
                    scope.isOpen = !scope.isOpen;
                };

                scope.onToggle = function (opt, $event) {
                    // keep the panel open while the user picks multiple formats
                    if ($event) { $event.stopPropagation(); }
                    if (!scope.available(opt)) { return; }

                    var trimmed = String(opt).trim();
                    var idx = _.findIndex(scope.selected, function (f) {
                        return String(f).trim() === trimmed;
                    });
                    if (idx > -1) {
                        scope.selected.splice(idx, 1); // mutate in place -> controller sees it
                    } else {
                        scope.selected.push(trimmed);
                    }
                    scope.onChange();
                };

                scope.clearAll = function ($event) {
                    if ($event) { $event.stopPropagation(); }
                    scope.selected.splice(0, scope.selected.length); // empty in place
                    scope.onChange();
                };

                // Close when clicking anywhere outside this dropdown.
                function handleDocumentClick(e) {
                    if (!element[0].contains(e.target)) {
                        scope.$apply(function () { scope.isOpen = false; });
                    }
                }
                $document.on('click', handleDocumentClick);
                scope.$on('$destroy', function () {
                    $document.off('click', handleDocumentClick);
                });
            }
        };
    }
    formatMultiSelect.$inject = ['$document'];
    angular
        .module("cstudioApp.directives")
        .directive("formatMultiSelect", formatMultiSelect);
})();
